export default __webpack_public_path__ + "static/media/logo@2x.83852e77.png";